<template>
    <div class="address">
        <h2 class="title">Adresse</h2>
        <form class="form" @submit.prevent="onSubmit">
            <label for="street" class="form-label">Auftragsort</label>
            <div class="input-group mb-3">
                <div style="width: 100%;">
                    <input v-model="street" type="text" placeholder="Straße + Hausnummer" id="street" required @blur="$options.methods.checkFormCompletition($event)">
                    <div class="error-hint">Pflichtfeld</div>
                </div>
                <div class="form-group d-flex">
                    <div>
                        <input v-model="zip" type="text" class="" placeholder="PLZ" required  @blur="$options.methods.checkFormCompletition($event)">
                        <div class="error-hint">Pflichtfeld</div>
                    </div>
                    <div>
                        <input v-model="city" type="text" class="" placeholder="Ort" required  @blur="$options.methods.checkFormCompletition($event)">
                        <div class="error-hint">Pflichtfeld</div>
                    </div>
                </div>
            </div>
            <label for="street" class="form-label">Auftragsdatum</label>
            <div class="form-check">
                <input v-model="is_flexible" class="form-check-input" type="checkbox" id="is_flexible">
                <label class="form-check-label" for="is_flexible">
                    Termin ist flexibel
                </label>
            </div>
            

            <select v-show="is_flexible && baseData" v-model="flexible_date"
                class="form-control form-select dropdown mb-3">
                <option v-for="(dateHint, dh) in baseData.flexibleDateHints" :key="dh" :value="dateHint.id">
                    {{ dateHint.hint_quicksale }}
                </option>
            </select>

            <template v-if="flexible_date == 3">
                <div class="mb-3">
                    <textarea v-model="flexible_date_info" class="form-control" rows="5" />
                </div>
            </template>

            <!-- <div class="form-group"> -->
            <template v-if="!is_flexible || flexible_date == 1">
                <div class="input-group  justify-content-between" :class="is_flexible ? 'd-flex' : 'd-block'">
                    <div class="d-flex flex-column" style="flex: 0 0 49%;">
                        <label for="date">von</label>
                        <input type="date" :required="!is_flexible || flexible_date == 1" v-model="starting_date" class="" id="date" />
                    </div>
                    <div class="d-flex flex-column" style="flex: 0 0 49%;" v-if="is_flexible">
                        <label for="date_alternative">bis</label>
                        <input type="date" :required="flexible_date == 1" v-model="ending_date" class="" id="date_alternative" />
                    </div>
                </div>
                <div class="input-group justify-content-between" :class="is_flexible ? 'd-flex' : 'd-block'">
                    <div style="flex: 0 0 49%;">
                        <input type="time" :required="!is_flexible || flexible_date == 1" v-model="starting_time" class="">
                    </div>
                    <div style="flex: 0 0 49%;" v-if="is_flexible">
                        <input type="time" :required="!is_flexible || flexible_date == 1" v-model="ending_time" class="">
                    </div>
                </div>
            </template>
            <!-- </div> -->

            <!-- <label for="street" class="form-label mt-3">Rechnungsadresse</label>
            <div class="form-check">
                <input v-model="same_as_jobs_address" class="form-check-input" type="checkbox"
                    id="same_as_jobs_address">
                <label class="form-check-label" for="same_as_jobs_address">
                    Identisch mit Auftragsort
                </label>
            </div>
            <div class="input-group" v-if="!same_as_jobs_address">
                <input v-model="invoice_street" type="text" class="" placeholder="Straße + Hausnummer" required>
                <div class="form-group d-flex">
                    <input v-model="invoice_zip" type="text" class="" placeholder="PLZ" required>
                    <input v-model="invoice_city" type="text" class="" placeholder="Ort" required>
                </div>
            </div>
            <div class="input-group mb-3">
                <div style="width: 100%;">
                    <input v-model="clients_contacts_name" type="text" class="" placeholder="Vor- und Nachname" required  @blur="$options.methods.checkFormCompletition($event)">
                    <div class="error-hint">Pflichtfeld</div>
                </div>
                <div style="width: 100%">
                    <input v-model="clients_name" type="text" class="" placeholder="Firmenname"  @blur="$options.methods.checkFormCompletition($event)">-->
                    <!-- <div class="error-hint">Pflichtfeld</div> -->
                <!-- </div>
            </div> -->
            <!-- <label for="street" class="form-label">Zahlungsart</label>
            <div class="input-group mb-3 flex-column">
                <div class="form-check" v-for="(payment, p) in paymentMethods" :key="p">
                    <input class="form-check-input" :value="payment.name" v-model="payment_method" type="radio"
                        name="flexRadioDefault" :id="`payment-${p}`">
                    <label class="form-check-label" :for="`payment-${p}`">
                        {{ payment.name }}
                    </label>
                </div>
            </div> -->
            <template v-if="flexible_date == 3">
                <label for="street" class="form-label">Kontaktdaten zur Terminvereinbarung</label>
                <div class="input-group mb-3">
                    <div style="width: 100%;">
                        <input v-model="flexible_date_contacts_mail" type="email" class="" placeholder="E-Mail-Adresse" required
                            @blur="$options.methods.checkFormCompletition($event)">
                        <div class="error-hint">Pflichtfeld</div>
                    </div>
                    <div style="width: 100%" class="has-helper-text">
                        <input v-model="flexible_date_contacts_mobile" type="tel" class="" @focus="setFocus($event)" placeholder="Handynummer"
                            required @blur="$options.methods.checkFormCompletition($event)">
                        <div class="error-hint">Pflichtfeld, Format: +49171111111</div>
                        <div class="help-text">Format: +49171111111</div>
                    </div>
                </div>
            </template>
            <label for="street" class="form-label">
                <span v-if="(flexible_date == 3)">Kontaktdaten Auftraggeber</span>
                <span v-else>Kontaktdaten</span>
            </label>
            <div class="input-group mb-3">
                <div style="width: 100%;">
                    <input v-model="clients_contacts_mail" type="email" class="" placeholder="E-Mail-Adresse" required @blur="$options.methods.checkFormCompletition($event)">
                    <div class="error-hint">Pflichtfeld</div>
                </div>
                <div style="width: 100%" class="has-helper-text">
                    <input v-model="clients_contacts_mobile" type="tel" class="" @focus="setFocus($event)" placeholder="Handynummer" required @blur="$options.methods.checkFormCompletition($event)">
                    <div class="error-hint">Pflichtfeld, Format: +49171111111</div>
                    <div class="help-text">Format: +49171111111</div>
                </div>
            </div>
            <Button type="submit" class="my-4">
                Weiter
            </Button>
        </form>
    </div>
</template>
<script>
    import {
        mapActions,
        mapGetters,
    } from 'vuex'
    import Button from '../components/ux/Button.vue';
    import router from '../router';
    export default {
        name: "Addresses",
        components: { Button },
        computed: {
            ...mapGetters("orders", [
                "fetching",
                "fetchingErrorCode",
                "fetchingError", 
                "location", 
                "date", "baseData", "paymentMethods", "invoiceAddress",
                "auth"
            ]),
            street: {
                get() {
                    return this.location.street;
                },
                set(value) {
                    this.$store.commit("orders/updateLocation", {
                        street: value
                    });
                },
            },
            zip: {
                get() {
                    return this.location.zip;
                },
                set(value) {
                    this.$store.commit("orders/updateLocation", {
                        zip: value
                    });
                },
            },
            city: {
                get() {
                    return this.location.city;
                },
                set(value) {
                    this.$store.commit("orders/updateLocation", {
                        city: value
                    });
                },
            },
            flexible_date_info: {
                get() {
                    return this.date.info;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        info: value
                    });
                }
            },
            is_flexible: {
                get() {
                    return this.date.is_flexible;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        is_flexible: value
                    });
                },
            },
            same_as_jobs_address: {
                get() {
                    return this.invoiceAddress.same_as_jobs_address;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        same_as_jobs_address: value
                    });
                },
            },
            invoice_street: {
                get() {
                    return this.invoiceAddress.street;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        street: value
                    });
                },
            },
            invoice_zip: {
                get() {
                    return this.invoiceAddress.zip;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        zip: value
                    });
                },
            },
            invoice_city: {
                get() {
                    return this.invoiceAddress.city;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        city: value
                    });
                },
            },
            flexible_date: {
                get() {
                    return this.date.flexible_date;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        flexible_date: value
                    });
                },
            },
            starting_date: {
                get() {
                    return this.date.starting_date;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        starting_date: value
                    });
                },
            },
            ending_date: {
                get() {
                    return this.date.ending_date;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        ending_date: value
                    });
                },
            },
            starting_time: {
                get() {
                    return this.date.starting_time;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        starting_time: value
                    });
                },
            },
            ending_time: {
                get() {
                    return this.date.ending_time;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        ending_time: value
                    });
                },
            },
            clients_name: {
                get() {
                    return this.baseData.clients_name;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_name: value
                    });
                },
            },
            clients_contacts_name: {
                get() {
                    return this.baseData.clients_contacts_name;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_contacts_name: value
                    });
                },
            },
            clients_contacts_mail: {
                get() {
                    return this.baseData.clients_contacts_mail;
                },
                set(value) {
                    this.$store.commit('orders/signInReset')
                    this.$store.commit("orders/storeBaseData", {
                        clients_contacts_mail: value
                    });
                },
            },
            clients_contacts_mobile: {
                get() {
                    return this.baseData.clients_contacts_mobile;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_contacts_mobile: value
                    });
                },
            },
            flexible_date_contacts_mail: {
                get() {
                    return this.baseData.flexible_date_contacts_mail;
                },
                set(value) {
                    this.$store.commit('orders/signInReset')
                    this.$store.commit("orders/storeBaseData", {
                        flexible_date_contacts_mail: value
                    });
                },
            },
            flexible_date_contacts_mobile: {
                get() {
                    return this.baseData.flexible_date_contacts_mobile;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        flexible_date_contacts_mobile: value
                    });
                },
            },
            payment_method: {
                get() {
                    const method = this.paymentMethods.filter(p => p.selected);
                    if (method.length > 0) {
                        return method[0].name;
                    }
                    return false;
                },
                set(value) {
                    this.$store.commit("orders/updatePaymentMethod", {
                        selected_payment_method: value
                    });
                },
            },
        },
        methods: {
            ...mapActions("orders", ["fetchArticles"]),
            onSubmit() {
                this.$options.methods.scrollTop();
                if (!this.auth.authenticated) {
                    router.push('Signin');
                    this.$store.dispatch("orders/navigate", 4);
                } else {
                    this.$options.methods.goToPath({ name: 'Summary', step: 5 });
                }
            },
            setFocus(e) {
                const { target } = e;
                if (!target) {
                    return;
                }

                const hasHelperText = target.closest('.has-helper-text');
                if (!hasHelperText) {
                    return;
                }

                hasHelperText.classList.add('focus');

            }
        }
    }
</script>

<style lang="scss" scoped>
.form {
    .form-group {
    
        &.d-flex {
            column-gap: 10px;
            width: 100%;
            
            div {
                width: 100%;
            }

            div:first-of-type {
                width: 33%;
            }
        }
    }
    
    .form-label {
        margin-bottom: 14px;
    }

    .form-check-label {
        font-weight: 300;
    }

    .form-check {
        margin-bottom: 10px;
    }
    
    input:not([type="checkbox"]):not([type="radio"]) {
        margin-bottom: 10px;
    }
}

@media (min-width: 768px) {
    .address {
        padding: 30px;
        border: 1px solid $border-color;
        margin-bottom: 100px;
    }
}
</style>